export const STAKING_SETTINGS_LIST = "STAKING_SETTINGS_LIST";
export const STAKING_SETTINGS_EDIT = "STAKING_SETTINGS_EDIT";
export const STAKING_SETTINGS_UPDATE = "STAKING_SETTINGS_UPDATE";